import { convertToMapById } from "helpers/convertToMap";
import { orderArrayV2 } from "helpers/orderArray";
import { createSelector } from "reselect";

export const ordersSelector = createSelector((state) => {
  const stations = state.companies.stations
  const orders = state.orders.orders.map(order => {
    return {
      ...order,
      station: stations[order?.idStation]?.label,
      brand: order?.serviceComplement?.brand?.name || null,
      origin: order?.serviceComplement?.origin || null
    }
  })
  return orders
}, orders => orders)

export const orderUnitsSelector = createSelector(state => {
  const units = convertToMapById(state.unitsReducer.units);
  const order = state.orders.order
  const unitsFiltered = units.filter(unit => unit.idStation === order.idStation &&
    (unit.type !== order.type && unit.type === 'ESTACION' ? unit.type === 'ESTACION' : unit.type === order.type))
    const sortUnits = orderArrayV2(unitsFiltered, 'label')
    return sortUnits
  }, unitsFiltered => unitsFiltered)
  
  export const couponsSelector = createSelector(
    state => {
    const units = state.unitsReducer.units;
    const coupons = state.coupons.coupons;
    const order = state.orders.order;
    let filteredCoupons = [];

    if(coupons.length > 0) {
      if(units[order.idUnit]?.type === 'ESTACION' ||  units[order.idUnit]?.type === 'ESTACIONARIO') {
        filteredCoupons = coupons.filter(cp => cp.rules && cp.rules.find(rule => rule.rule.includes("LTS"))).map(cp => {
          return {
            ...cp,
            rules: cp.rules.find(rule => rule.rule.includes("LTS"))
          }
        })
      }
      
      else if(units[order.idUnit]?.type === 'PORTATIL') {
        filteredCoupons = coupons.filter(cp => cp.rules && cp.rules.find(rule => rule.rule.includes("KILOS"))).map(cp => {
          return {
            ...cp,
            rules: cp.rules.find(rule => rule.rule.includes("KILOS"))
          }
        })
      }
    }

    return filteredCoupons;
  },
  couponsFiltered => couponsFiltered
);